import { render, staticRenderFns } from "./mo-radio-wrapper.html?vue&type=template&id=7fe20156&scoped=true&external"
import script from "./mo-radio-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-radio-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-radio-wrapper.scss?vue&type=style&index=0&id=7fe20156&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe20156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe20156')) {
      api.createRecord('7fe20156', component.options)
    } else {
      api.reload('7fe20156', component.options)
    }
    module.hot.accept("./mo-radio-wrapper.html?vue&type=template&id=7fe20156&scoped=true&external", function () {
      api.rerender('7fe20156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-radio-wrapper/mo-radio-wrapper.vue"
export default component.exports